import n from "./ghl-ui.es1516.js";
import i from "./ghl-ui.es1506.js";
import m from "./ghl-ui.es1524.js";
import e from "./ghl-ui.es1505.js";
import f from "./ghl-ui.es1466.js";
function u(o, t) {
  if (f(2, arguments), n(t) !== "object" || t === null)
    throw new RangeError("values parameter must be an object");
  var r = i(o);
  return isNaN(r.getTime()) ? /* @__PURE__ */ new Date(NaN) : (t.year != null && r.setFullYear(t.year), t.month != null && (r = m(r, t.month)), t.date != null && r.setDate(e(t.date)), t.hours != null && r.setHours(e(t.hours)), t.minutes != null && r.setMinutes(e(t.minutes)), t.seconds != null && r.setSeconds(e(t.seconds)), t.milliseconds != null && r.setMilliseconds(e(t.milliseconds)), r);
}
export {
  u as default
};
